import React from 'react';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import Loading from './index';

export interface WithLoadingProps {
  loading?: boolean;
  loadingText?: string;
  contentSize?: boolean;
  detail?: boolean;
  signatureOnly?: boolean;
  open?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: 'relative',
      height: '100%',
    },
    loader: {
      position: 'fixed',
      zIndex: 9999,
      width: '100%',
      height: '100%',
      top: '0',
      left: '0',
      backgroundColor: 'rgba(255,255,255,.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    loaderText: {
      position: 'fixed',
      top: 'calc(50% + 50px)',
      textAlign: 'center',
    },

    detail: (props: { open?: boolean, signatureOnly?: boolean }) => ({
      minHeight: '100%',
      height: 'auto',
      '&:before':{
        transition: '0.5s all',
        position: 'absolute',
        left: 0,
        top: 0,
        content: '""',
        display: !props.signatureOnly ? 'inline-block' : 'none',
        height: '100%',
        background: '#000',
        [theme.breakpoints.down('xs')]: {
          display: 'none'
        }
      },
      '&.open:before': {
        width: '250px',
        [theme.breakpoints.down('sm')]: {
          width: '56px'
        }
      },
      '&.closed:before': {
        width: '56px'
      },

    }),

  }),
);

/**
 * HOC component which makes pass to children component props Loading
 * and shows loading progress.
 * @param Component
 */
const withLoading = <P extends object>(Component: React.ComponentType<P>) => {
  const WithLoading: React.FC<P & WithLoadingProps> = (props) => {
    const { loading, loadingText, contentSize, detail, signatureOnly, open, ...rest } = props;
    const classes = useStyles({open, signatureOnly});
    const originalComponent = <Component {...(rest as P)} />;

    return (
      <Box className={`${classes.container} ${detail ? classes.detail : ''} ${open ? 'open' : 'closed'}`}>
        {loading && (
          <Box className={classes.loader}>
            <Loading contentSize={contentSize} />
            {loadingText && <span className={classes.loaderText}>{loadingText}</span>}
          </Box>
        )}
        {originalComponent}
      </Box>
    );
  };
  return WithLoading;
};

export default withLoading;
